import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetShoppingCartItem
 */
export default {
    /**
     * Get cart's item amount.
     */
    apiGetCartCount: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiShoppingCartUrl() + '/cart/count';
        let params = {
            countQuantity: true,
        };
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    /**
     * Get total item's quantity in cart.
     * @deprecated //! พี่บอลบอกไม่ให้ใช้แบบนี้ ไปใช้ apiGetCartCount
     */
    apiGetCartQuantityCount: function() {
        return this.apiGetCartList().pipe(map((data) => {
            var total = 0;
            var list = data.list;
            if (list) {
                for (var items of list) {
                    for (var item of items.items) {
                        total += item.Quantity;
                    }
                }
            }
            return total;
        }));
    },

    /**
     * Get cart's list.
     */
    apiGetCartList: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiShoppingCartUrl() + '/cart/list_summary';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Add item(s) to cart.
     * @param {Object} cartParams /core/ShoppingCart/model/AddCartModel.js
     */
    apiAddToCart: (cartParams) => {
        let token = Account.getToken();
        let url = ConfigManager.getApiShoppingCartUrl() + '/cart/adds';
        return BzbsApi.connectBzbsPost(url, token, cartParams).pipe(map((res) => {
            return res.data;
        }));
    },
}
